import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import { getdatabasekey, getKeyMode, getPermissions } from "../api/configHelper";


export default function DatabaseKeyPage() {
  const [key, setKey] = useState(sessionStorage.getItem("databaseKey") || "");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [customKey, setCustomKey] = useState("");
  const [keyMode, setKeyMode] = useState("fixed");
  const [permissions, setPermissions] = useState({});
  const [permissionsLoaded, setPermissionsLoaded] = useState(false);
  const navigate = useNavigate();
  const selectRef = useRef(null);

  
  useEffect(() => {
  const loadPermissions = async () => {
    try {
      const perms = await getPermissions();
      setPermissions(perms);
    } catch (err) {
      console.error("Failed to load permissions", err);
    } finally {
      setPermissionsLoaded(true);
    }
  };
  loadPermissions();
}, []);

  useEffect(() => {
  const fetchOptions = async () => {
    try {
      const [keys, mode] = await Promise.all([
        getdatabasekey(),
        getKeyMode()
      ]);
      setKeyMode(mode);

      let finalOptions = [...keys];

      // 🔐 Only allow "Others" if permission is 1
      if (permissions.others === 1) {
        finalOptions.push("Others");
      }

      setOptions(finalOptions);
    } catch (err) {
      console.error("Failed to load database keys:", err);
      setError("Failed to load database keys.");
    }
  };

  if (permissionsLoaded) {
    fetchOptions();
  }
}, [permissions, permissionsLoaded]);

  useEffect(() => {
    if ((options.length > 0 || keyMode === "custom") && selectRef.current) {
      selectRef.current.focus();
    }
  }, [keyMode, options]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const finalKey = keyMode === "custom" || key === "Others" ? customKey : key;
    if (!finalKey.trim()) {
      setError("Please select or enter a database key.");
      return;
    }
    setLoading(true);
    try {
      sessionStorage.setItem("databaseKey", finalKey);
      const companyData = await api.Companydetails();
      sessionStorage.setItem(
        "companyDetails",
        JSON.stringify(companyData)
      );
      navigate(`/login${window.location.search}`);
    } catch (err) {
      setError("Failed to fetch company details. Try again.");
    }
    setLoading(false);
  };

  return (
    <div className="relative flex items-center justify-center w-screen h-screen">

      {/* ---- Background Gradient ---- */}
      <div
        className="absolute inset-0"
        style={{
          background: "linear-gradient(135deg, var(--base-200), var(--base-100))",
        }}
      />

      {/* ---- Floating Blobs ---- */}
      <div
        className="absolute rounded-full w-72 h-72 blur-3xl opacity-20"
        style={{
          background: "var(--primary)",
          top: "10%",
          left: "5%",
        }}
      ></div>

      <div
        className="absolute rounded-full w-96 h-96 blur-3xl opacity-20"
        style={{
          background: "var(--primary-focus)",
          bottom: "5%",
          right: "10%",
        }}
      ></div>

      {/* ---- CARD ---- */}
      <div className="relative z-10 w-full max-w-md db-card animate-fade-in">

        {/* ---- IMAGE INSIDE CARD ---- */}
        <div className="flex justify-center mb-6">
          <img
            src="/assets/dbkey.jpg"
            alt="Database Key"
            className="object-cover w-32 h-32 shadow-lg rounded-2xl"
          />
        </div>

        {/* ---- TITLE ---- */}
        <div className="mb-4 text-center">
          <h2
            className="text-3xl font-bold"
            style={{
              background: "linear-gradient(135deg, var(--primary), var(--primary-focus))",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Select Cloud Key
          </h2>
          <p className="mt-2 text-gray-800">Choose your ERP environment</p>
        </div>

        {/* ---- FORM ---- */}
        <form onSubmit={handleSubmit}>
          {keyMode === "fixed" ? (
            <select
              ref={selectRef}
              value={key}
              onChange={(e) => setKey(e.target.value)}
              className="w-full cursor-pointer input-professional"
            >
              <option value="">-- Select Database Key --</option>
              {options.map((db) => (
                <option key={db} value={db}>
                  {db}
                </option>
              ))}
            </select>
          ) : (
            <input
              ref={selectRef}
              type="text"
              value={customKey}
              onChange={(e) => setCustomKey(e.target.value)}
              className="w-full input-professional"
              placeholder="Enter database key"
            />
          )}
          {keyMode === "fixed" && permissions.others === 1 && key === "Others" && (
            <input
              type="text"
              value={customKey}
              onChange={(e) => setCustomKey(e.target.value)}
              className="w-full mt-4 input-professional"
              placeholder="Enter custom database key"
            />
          )}

{error && (
  <div className="p-3 mt-4 text-center text-red-700 bg-red-100 rounded-xl">
    {error}
  </div>
)}

          {/* ---- BUTTON ---- */}
          <button
            type="submit"
            className="w-full mt-6 btn-professional"
            disabled={loading}
          >
            {loading ? "Loading..." : "Continue to Login"}
          </button>
        </form>

      </div>
    </div>
  );
}
